import { useEffect, useState } from 'react'
import { FaArrowDown } from 'react-icons/fa'

function ScrollToBottomButton() {
  const [showButton, setShowButton] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY + window.innerHeight
      const bottomPosition = document.documentElement.scrollHeight - 100

      if (scrollPosition < bottomPosition && !showButton) {
        setShowButton(true)
      } else if (scrollPosition >= bottomPosition && showButton) {
        setShowButton(false)
      }
    }

    window.addEventListener('scroll', handleScroll)
    handleScroll() // Initial call to ensure state is correct on load

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [showButton]) // Include showButton to ensure state changes are captured

  const scrollToBottom = () => {
    window.scrollTo({
      top: document.documentElement.scrollHeight,
      behavior: 'smooth'
    })
  }

  return (
    <>
      {showButton && (
        <button
          onClick={scrollToBottom}
          className="fixed bottom-28 right-4 lg:right-72 p-3 text-lg bg-white text-black border border-gray-200 rounded-full z-50"
        >
          <FaArrowDown />
        </button>
      )}
    </>
  )
}

export default ScrollToBottomButton
